import { Box, Typography } from "@mui/material";

const Projects = () => (
  <Box>
    <Typography variant={"h2"}>Projects</Typography>
    <Typography variant={"body1"}>Projects body copy here</Typography>
  </Box>
);

export default Projects;
